<template>
  <div class="create-post-comp">
    <div class="d-flex align-items-center mb-4 mob-shadow">
      <font-awesome-icon :icon="['far', 'arrow-left']" class="font-black mr-3 font20 cp" @click="changeScreen('add')" />
      <h4 class="fw700 font24 gray700 mb-0">Pictures</h4>
      <div class="saveBtn ml-auto br6 p1224 font-white font14 fw700 cp show-in-mobile" :style="{ background: getPrimaryColor() }" @click="addImg">Done</div>
      <font-awesome-icon :icon="['fal', 'times']" class="hide-in-mobile font-black ml-auto cp font20" @click="hide" />
    </div>

    <div class="eachImgContainer position-relative mb-4" v-for="(eachImage, ind) in ImagesArray" :key="eachImage">
      <img v-if="eachImage.type.includes('image')" :src="eachImage.url" />
      <video v-if="eachImage.type.includes('video')" :src="eachImage.url" controls />
      <font-awesome-icon
        :icon="['far', 'times']"
        class="gray500 position-absolute bg-gray100 ar1 font24 rounded-circle cp"
        :style="{ top: '10px', right: '10px', 'z-index': 6, padding: '2px' }"
        @click="handleCancelImage(ind)"
      />
      <div class="bottomPart bg-gray100 p-3">
        <a-switch class="px-1 dovedailySwitch" :checked="eachImage.sensitive" @change="handleSensitive(ind)" :style="{ '--P500C': getPrimaryColor().split(' ')[0] }" />
        <span class="gray900 font14 ml-2">Is sensitive</span>
      </div>
    </div>
    <div class="saveBtn ml-auto br6 p1224 font-white font14 fw700 cp hide-in-mobile" :style="{ background: getPrimaryColor() }" @click="addImg">Done</div>
  </div>
</template>

<script>
export default {
  name: "AllPicturesScreen",
  props: {
    ImagesArrayProp: Array,
    getImageData: Function,
    changeScreen: Function,
    hide: Function,
  },
  created() {
    // console.log("images ->", this.ImagesArray);
    this.ImagesArray = this.ImagesArrayProp
  },
  data() {
    return { ImagesArray: [] }
  },
  methods: {
    addImg() {
      this.getImageData(this.ImagesArray)
    },
    handleCancelImage(i) {
      this.ImagesArray.splice(i, 1)
    },
    handleSensitive(i) {
      this.ImagesArray = this.ImagesArray.map((img, ind) => {
        if (i === ind) {
          return { ...img, sensitive: !img.sensitive }
        } else {
          return img
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.ant-switch-checked {
  background: #e1eaf7;
}
.ant-switch::after {
  transform: scale(1.5) !important;
  background: #cbd5e1;
  width: 19px;
  height: 19px;
}
.ant-switch-checked::after {
  transform: translateX(-100%) scale(1.5) !important;
  background: var(--P500C);
}
.dovedailySwitch {
  background: #e1eaf7 ;
  transform: scale(0.7);
  min-width: 50px;
}
.saveBtn {
  width: fit-content;
}
img,
video {
  width: 100%;
  max-height: 360px;
  object-fit: contain;
}
.bottomPart {
  border-radius: 0px 0px 8px 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/home/createNewPost/Pictures.vue